/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Button } from '@ui/components';

export const DefaultButtonExample = () => <Button>Default action</Button>;

export const DisabledButtonExample = () => (
    <Button disabled variant="secondary">
        Disabled action
    </Button>
);

export const LoadingButtonExample = () => (
    <Button loading variant="primary">
        Loading action
    </Button>
);

export const DangerButtonExample = () => (
    <Button variant="danger">Delete report</Button>
);

export const GhostButtonExample = () => (
    <Button variant="ghost">Ghost action</Button>
);

export const LongTextButtonExample = () => (
    <Button variant="secondary">
        Review all selected media value center placements before exporting
    </Button>
);
